import { APIAction } from '../apiManager';

const buildSharedApiV2Url = (endpoint: string) => {
  const baseUrl = process.env.REACT_APP_SHARED_API_V2_URL;

  if (!baseUrl) {
    throw new Error('Shared API v2 URL is not configured');
  }

  return `${baseUrl.replace(/\/$/, '')}${endpoint}`;
};

export class SharedApiV2RequestError extends Error {
  status?: number;

  constructor(status?: number) {
    super('Shared API v2 request failed');
    this.name = 'SharedApiV2RequestError';
    this.status = status;
  }
}

export async function activateClosietyUser(data: { token: string; password: string }) {
  const response = await fetch(buildSharedApiV2Url('/auth/activation'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      token: data.token,
      password: data.password
    })
  });

  let responseBody: any = null;
  try {
    responseBody = await response.json();
  } catch {
    responseBody = null;
  }

  if (response.status === 200 && responseBody?.status === 'completed') {
    return responseBody;
  }

  throw new SharedApiV2RequestError(response.status);
}

export async function handleSharedApiV2(action: APIAction) {
  switch (action.method) {
    case 'activate-closiety-user':
      return activateClosietyUser({
        token: action.data.token,
        password: action.data.password
      });
    default:
      console.info('[ApiManager > handleAPIAction > handleSharedApiV2] - Unknown method');
      break;
  }
}
